import Register from "./components/Register";
import React from "react";
import ipConfig from "./ipConfig.json";
import { Route, Switch } from "react-router-dom";
import Login from "./components/Login";
import { ThemeProvider } from '@mui/system';
import theme from "./theme.js";
import Products from "./components/Products";
import Thanks from "./components/Thanks.js"
import Checkout from "./components/Checkout"

export const config = {
  endpoint: "https://qkart-frontend-cxmd.onrender.com/api/v1",
};

function App() {
  return (
    <div className="App">
      {/* TODO: CRIO_TASK_MODULE_LOGIN - To add configure routes and their mapping */}
      <React.StrictMode>
        <ThemeProvider theme={theme}>
          <Switch>
            <Route exact path='/'><Products/></Route>
            <Route path='/register'><Register/></Route>
            <Route path='/login'><Login/></Route>
            <Route path='/checkout'><Checkout/></Route>
            <Route path='/thanks'><Thanks/></Route>
            
          </Switch>
        </ThemeProvider>
      </React.StrictMode>
          {/* <Register /> */}
          
    </div>
  );
}

export default App;
